// extracted by mini-css-extract-plugin
export default {"productName":"Tests_productName__9nJ0U","actions":"Tests_actions__jYwdS","button":"Tests_button__Nl2Hv"};